export const errorMessages = {
	IS_REQUIRED: 'Is Required',
	SHOULD_BE_POSITIVE: 'Should be positive',
	SHOULD_BE_INTEGER: 'Should be integer',
};
